export const getTranslations = t => {
  return {
    invalidCardHolder: t("kf.payment.aci.invalidCardHolder"),
    enterFullName: t("kf.payment.aci.enterFullName"),
    genericError: t("kf.error.message.genericError"),
    checkOutTimeoutError: t("kf.error.message.checkOutTimeoutError"),
  }
}
